module.exports = "/_next/static/resources/photo-4-e0d26c7b8be4c33821c35e1f8973f89f.jpg";